module.exports = __webpack_public_path__ + "img/pdf.5aadf887.png";